import { render, staticRenderFns } from "./BreadcrumbDropdown.vue?vue&type=template&id=61e06fcc"
import script from "./BreadcrumbDropdown.vue?vue&type=script&lang=js"
export * from "./BreadcrumbDropdown.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports